export default "__VITE_ASSET__DE6j9MSh__"